import { AlertWithCase, AlertWithCaseSummary } from "src/types/alert";
import { Case, CaseSummary, CaseVersion } from "src/types/case";

export const getAlertCase = (alert: AlertWithCase, version: CaseVersion): Case | null => {
  switch (version) {
    case "creation":
      return alert.creationCase;
    case "current":
      return alert.currentCase;
    case "validation":
      return alert.validationCase;
    default:
      console.error(`Unexpected defaultAlertVersion value: ${version}`);
      return alert.creationCase;
  }
};

export const getAlertCaseSummary = (
  alert: AlertWithCaseSummary,
  version: CaseVersion
): CaseSummary | null => {
  switch (version) {
    case "creation":
      return alert.creationCase;
    case "current":
      return alert.currentCase;
    case "validation":
      return alert.validationCase;
    default:
      console.error(`Unexpected defaultAlertVersion value: ${version}`);
      return alert.currentCase;
  }
};
